<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }" >
      <v-btn
        class="mx-2"
        color="primary"
        fab
        small
        dark
        v-bind="attrs"
        v-on="on"
        @click="openNewSchedules"
      >
        <v-icon dark> mdi-plus </v-icon>
      </v-btn>
    </template>
    <span>Nova Playlist</span>
  </v-tooltip>
</template>

<script>
export default {
  methods:{
    openNewSchedules(){
      this.$router.push('add')
    }
  }
};
</script>

<style lang="scss" scoped>
</style>